import { searchProduct } from 'JS/API';
import { useState } from 'react';
import { TfiClose } from "react-icons/tfi";

const ProductSearchModal = ({
    setIsSearchOpen,
    selectedItem,
    productItemList,
    setProductItemList,
    setIsClassLocked,
}) => {
    const [input, setInput] = useState('');
    const [searchData, setSearchData] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [searchAttempted, setSearchAttempted] = useState(false);

    const toggleSelectAll = () => {
        setSelectAll(prev => !prev);
        setSearchData(prev =>
            prev.map(item => ({ ...item, selected: !selectAll }))
        );
    };

    const toggleItemSelection = idx => {
        setSearchData(prev =>
            prev.map((item, index) =>
                index === idx ? { ...item, selected: !item.selected } : item
            )
        );
    };

    const searchFunc = async () => {
        if (input.trim() === '') return alert('검색어를 입력해 주세요.');
        setSearchAttempted(true);

        try {
            const result = await searchProduct(selectedItem?.kind_code, input);
            const dataArray = result?.data?.product_name || [];

            if (Array.isArray(dataArray) && dataArray.length > 0) {
                const formatted = dataArray.map(product => ({
                    kind_code: selectedItem?.kind_code,
                    product,
                    selected: false,
                }));
                setSearchData(formatted);
            } else {
                setSearchData([]);
            }
        } catch (err) {
            console.error('상품 검색 중 오류 발생:', err);
            alert('상품 검색에 실패했습니다. 다시 시도해 주세요.');
        }
    };


    const selectAllChecked = searchData.every(item => item.selected);
    const indeterminate =
        searchData.some(item => item.selected) && !selectAllChecked;

    return (
        <div className='modal-bg'>
            <div className='modal column'>
                <div className='head'>
                    <h3>키워드 검색하여 상품추가</h3>
                    <div className="personnel-modal-close" onClick={() => setIsSearchOpen(false)}>
                        <TfiClose />
                    </div>
                </div>
                <hr />
                <div className='row input-section search'>
                    <span>상품 :</span>
                    <input
                        type='text'
                        placeholder='검색할 상품의 키워드를 입력하세요.'
                        className='common-text-input'
                        value={input}
                        onChange={e => setInput(e.target.value)}
                        onKeyDown={e => {
                            if (e.key === 'Enter') searchFunc();
                        }}
                    />
                    <button className='search-btn' onClick={searchFunc}>
                        검색
                    </button>
                </div>

                {searchData.length > 0 && (
                    <>
                        <div className='input-table-wrap'>
                            <div className='t-head'>
                                <div className='input-wrap'>
                                    <label>
                                        <input
                                            type='checkbox'
                                            className='checkbox-input'
                                            checked={selectAllChecked}
                                            onChange={toggleSelectAll}
                                            ref={input => {
                                                if (input) input.indeterminate = indeterminate;
                                            }}
                                        />
                                        <span className='checkbox-custom'></span>
                                    </label>
                                </div>
                                <div className='content'>상품</div>
                            </div>
                            {searchData.map((item, idx) => (
                                <div className='t-body' key={idx}>
                                    <label className='input-wrap'>
                                        <input
                                            type='checkbox'
                                            className='checkbox-input'
                                            checked={item.selected}
                                            onChange={() => toggleItemSelection(idx)}
                                        />
                                        <span className='checkbox-custom'></span>
                                        <span className='content'>{item.product}</span>
                                    </label>
                                </div>
                            ))}

                        </div>

                        <div className='btn-wrap row side'>
                            <button
                                className='gradient-btn'
                                onClick={() => {
                                    const selectedProducts = searchData.filter(item => item.selected);
                                    if (selectedProducts.length === 0) {
                                        return alert('선택된 상품이 없습니다.');
                                    }

                                    const duplicates = selectedProducts.filter(selected =>
                                        productItemList.some(
                                            existing =>
                                                existing.kind_code === selected.kind_code &&
                                                existing.product === selected.product
                                        )
                                    );

                                    if (duplicates.length) {
                                        return alert('이미 있는 상품입니다.');
                                    }

                                    setProductItemList(prev => [...prev, ...selectedProducts]);
                                    setIsClassLocked(true);
                                    setIsSearchOpen(false);
                                }}
                            >
                                저장
                            </button>
                            <button
                                className='gray-btn'
                                onClick={() => {
                                    setInput('');
                                    setIsSearchOpen(false);
                                }}
                            >
                                취소
                            </button>
                        </div>
                    </>
                )}

                {searchAttempted && searchData.length === 0 && (
                    <div className="no-result-message">검색 결과가 없습니다.</div>
                )}
            </div>
        </div>
    );
};

export default ProductSearchModal;
